module.exports = __webpack_public_path__ + "static/b-1-c745190b21017e1584b6f628badc5c04.png";